<template>
  <v-dialog v-model="dialog" attach="#app">
    <template v-slot:activator="{ on }">
      <div
        @mouseenter="hover = true"
        @mouseleave="hover = false"
        class="py-6"
        :style="{ position: 'relative' }"
      >
        <slot name="activator"></slot>
        <v-fade-transition>
          <v-overlay v-if="hover" absolute color="primary">
            <v-btn v-on="on" fab text large
              ><v-icon large>mdi-magnify-plus-outline</v-icon></v-btn
            >
          </v-overlay>
        </v-fade-transition>
      </div>
    </template>
    <v-card
      :style="{
        position: 'relative',
        height: $vuetify.breakpoint.height - 100 + 'px'
      }"
    >
      <v-btn
        @click="dialog = false"
        text
        elevation="1"
        :style="{
          position: 'absolute',
          top: '25px',
          right: '55px',
          zIndex: 99
        }"
        ><v-icon left>mdi-close</v-icon> close</v-btn
      >
      <div style="height:100% !important;overflow: auto;display:flex;">
        <v-img contain :src="value" :style="{ maxHeight: '100%' }"></v-img>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ImagePreview",

  props: {
    value: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      hover: false,
      dialog: false
    }
  },
  methods: {
    cancel() {
      this.dialog = false
    }
  }
}
</script>
